import React from 'react';
import type { V2Guard, V2Route } from '../units/types';

/** 旧 /lp-improve と同じくカード未登録ロック */
const guard: V2Guard = { kind: 'card' };

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  { path: 'lp-improve', Component: React.lazy(() => import('./LpImproveListPage')), guard },
  { path: 'lp-improve/:projectId', Component: React.lazy(() => import('./LpImproveWorkspacePage')), guard },
];

export default routes;
